export default "__VITE_PUBLIC_ASSET__37438bb6__"